module.exports = __webpack_public_path__ + "static/media/invoice-active.981e385a.svg";